import { Size, t } from '@bms2/shared';
import { Textarea } from '../../components/controls';
import { documentEditStyles as styles } from './DocumentEditPage';

/**
 * 🔒 The notes a document's sheet says to the other party (piece 22; T124,
 * decision 0683): a multi-line box under the form's header, labelled for the
 * customer, or for the vendor on the Purchase Order and the Bill. Region 7
 * prints what is typed, one paragraph per line, on the first sheet.
 */
export function CustomerNotesBox({ value, onChange, party = 'customer', name }: { value: string; onChange: (next: string) => void; party?: 'customer' | 'vendor'; name: string }) {
  return (
    <div className={styles.wide} data-customer-notes={name}>
      <Textarea size={Size.Large} label={party === 'vendor' ? t('document.edit.notesToVendor') : t('document.edit.notesToCustomer')} value={value} onChange={onChange} name={`${name}CustomerNotes`} />
      <p className={styles.hint}>{t('document.edit.notesHint')}</p>
    </div>
  );
}
